import React from "react"
import TabTitle from './tabs/TabTitle.jsx';
import TabBody from './tabs/TabBody.jsx';
import axios from 'axios';
import { ErrorMessage } from './shared/ErrorMessage.jsx';
import I18n from 'i18n-js';
import './translations.js';
class EditEntryStep extends React.Component {
  constructor(props) {
    super(props);
    I18n.locale = this.props.locale;
    var available = [
      this.props.show.stall_types.length > 0,
      this.props.show.campsite_types.length > 0,
      this.props.show.hay.available,
      this.props.show.bedding.available,
      this.props.show.paddocks.available,
      this.props.show.horse_checks.available
    ];
    var tabs = [
        {id: 'stalls', name: I18n.t("season_stalls.stalls"), note: I18n.t("season_stalls.stabling_notes"), available: available[0]},
        {id: 'campsites', name: I18n.t("season_stalls.campsites"), note: I18n.t("season_stalls.campsite_notes"), available: available[1]},
        {id: 'hays', name: I18n.t("rts.services.hay"), resources: I18n.t("rts.services.resources.bales"), available: available[2]},
        {id: 'beddings', name: I18n.t("rts.services.bedding"), resources: I18n.t("rts.services.resources.bags"), available: available[3]},
        {id: 'paddocks', name: I18n.t("rts.services.paddocks"), resources: I18n.t("rts.services.resources.paddock")+`${this.props.show.paddocks.price_per}s`, available: available[4]},
        {id: 'horse_checks', name: I18n.t("rts.services.check"), resources: I18n.t("rts.services.resources.horse"), available: available[5]},
        {id: 'summary', name: I18n.t("fees.order_summary"), available: available.indexOf(true) > -1}
    ];
    this.state = {
      tabs: tabs,
      stallsWarning: this.props.entry.stall_warning || "",
      stallsNote: this.props.entry.stall_note || "",
      stallsDailyType: this.props.entry.stall_daily_type || "",
      stallsDailyReservations: this.props.entry.stall_daily_reservations,
      stallsShowType: this.props.entry.stall_show_type || "",
      stallsShowReservations: this.props.entry.stall_show_reservations || "",
      stallsShowAssigned: this.props.entry.stall_show_assigned || false,
      stallsAvailable: this.props.avbl_show_stalls,
      campsitesWarning: this.props.entry.campsite_warning || "",
      campsitesNote: this.props.entry.camspite_note || "",
      campsitesDailyType: this.props.entry.camspite_daily_type || "",
      campsitesDailyReservations: this.props.entry.camspite_daily_reservations,
      campsitesShowType: this.props.entry.camspite_show_type || "",
      campsitesShowReservations: this.props.entry.camspite_show_reservations || "",
      campsitesShowAssigned: this.props.entry.camspite_show_assigned || false,
      campsitesAvailable: this.props.avbl_show_campsites,
      adjustments: this.props.entry.adjustments || 0,
      hays: [],
      beddings: [],
      paddocks: [],
      horse_checks: [],
      services: this.props.entry.services,
      selectedTab: available.indexOf(true) > -1 ? tabs[available.indexOf(true)].id : false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectTab = this.selectTab.bind(this);
    this.tableInputChange = this.tableInputChange.bind(this);
    this.defaultChange = this.defaultChange.bind(this);
    this.updateReservations = this.updateReservations.bind(this);
    this.resetDailyReservations = this.resetDailyReservations.bind(this);
    this.resetShowReservations = this.resetShowReservations.bind(this);
    this.resetReservations = this.resetReservations.bind(this);


  }

  handleSubmit(step) {
    var reservations = {
      stall_note: this.state.stallsNote,
      stall_show_type: this.state.stallsShowType,
      stall_show_orders: (this.state.stallsShowReservations || "0"),
      stall_daily_type: this.state.stallsDailyType,
      stall_daily_orders: this.state.stallsDailyReservations,
      campsite_note: this.state.campsitesNote,
      campsite_show_type: this.state.campsitesShowType,
      campsite_show_orders: (this.state.campsitesShowReservations || "0"),
      campsite_daily_type: this.state.campsitesDailyType,
      campsite_daily_orders: this.state.campsitesDailyReservations
    }
    axios.put('/api/v1/entry', {
      entry_id: this.props.entry.entry_id,
      services: this.state.services,
      reservations: reservations
    })
        .then(response => window.location = `/entry_reg_wizard/${step}?entry_id=${this.props.entry.entry_id}`)
        .catch(error => {
              console.log(error.response.headers['error-message']);
              this.setState({
                stallsWarning: error.response.headers['error-message'].replace(/[^a-zA-Z ]/g, "")
              })
        })
  }

  selectTab(e) {
    this.setState({ selectedTab: e.target.id })
  }

  tableInputChange(e) {
    const state = this.state;
    var source = e.target.id.split(" ")[1];
    var id = e.target.id.split(" ")[0];
    var value = Number(e.target.value);

    var tempState = state[source].filter((element) => element.id != id);
    tempState.push({id: id, value: value});
    state[source] = tempState;

    var services = this.state.services;
    services = services.filter((element) => element.id != id || element.source !== source)
    services.push({id: id, value: value, source: source});
    state.services = services

    this.setState(state);

    if (this.props.secretary) {
      this.updateReservations();
    }

  }

  defaultChange(e) {
    const state = this.state;
    state[e.target.id] = e.target.value
    this.setState(state);

    this.resetReservations(e)
  }

  resetDailyReservations(source_type) {
    var services =  this.state.services.filter(service => {
      return service.source !=`${source_type}Reservations`;
    });

    var stalls_reservations_to_zero = this.state.stallsDailyReservations.map(res => {
      res.value = 0;
      return res
    });

    var campsites_reservations_to_zero = this.state.campsitesDailyReservations.map(res => {
      res.value = 0;
      return res
    });

    this.setState({ services: services,
                    stallsDailyReservations: stalls_reservations_to_zero,
                    campsitesDailyReservations: campsites_reservations_to_zero },
                    this.updateReservations)
  }

  resetShowReservations(source_type) {
    var key = `${source_type}Reservations`

    this.setState({ [key]: 0 }, this.updateReservations)
  }

  resetReservations(e) {
    var source_type = e.target.id.replace('Type', '')

    if(e.target.name == 'DailyType') {
      this.resetDailyReservations(source_type)
    } else if (e.target.name = 'showType') {
      this.resetShowReservations(source_type)
    }
  }

  updateReservations() {
    var reservations = {
      stall_note: this.state.stallsNote,
      stall_show_type: this.state.stallsShowType,
      stall_show_orders: (this.state.stallsShowReservations || "0"),
      stall_daily_type: this.state.stallsDailyType,
      stall_daily_orders: this.state.stallsDailyReservations,
      campsite_note: this.state.campsitesNote,
      campsite_show_type: this.state.campsitesShowType,
      campsite_show_orders: (this.state.campsitesShowReservations || "0"),
      campsite_daily_type: this.state.campsitesDailyType,
      campsite_daily_orders: this.state.campsitesDailyReservations
    }
    axios.put('/api/v1/entry', {
      entry_id: this.props.entry.entry_id,
      services: this.state.services,
      reservations: reservations
    })
      .then(response => this.setState({stallsAvailable: response.data.stalls_availability,
                                       campsitesAvailable: response.data.campsites_availability}))
      .catch(error => {
            console.log(error.response.headers['error-message']);
            this.setState({
              stallsWarning: error.response.headers['error-message'].replace(/[^a-zA-Z ]/g, "")
            })
          })
  }

  render () {
    return (
      <div className="wizard_wrapper">
        {!this.props.show.services_split && this.state.selectedTab ?
          <div>
            <ul className="nav nav-tabs entry" id="entriesTabs" role="tablist" style={{marginBottom: 0}}>
              {this.state.tabs.map((tab, index) => 
                tab.available ?
                  <TabTitle
                    key={index}
                    tab={tab}
                    selectedTab={this.state.selectedTab}
                    selectTab={this.selectTab}/>
                : undefined
              )}
            </ul>
            {this.state.selectedTab  ?
              <ErrorMessage message={this.state.stallsWarning}/> : undefined}
            <div className="tab-content" id="ridersTabsContent">
              {this.state.tabs.map((tab, index) => 
                <TabBody
                  key={index}
                  show={this.props.show}
                  selectedTab={this.state.selectedTab}
                  tab={tab}
                  tableInputChange={this.tableInputChange}
                  defaultChange={this.defaultChange}
                  editable={this.props.editable}
                  secretary={this.props.secretary}
                  summary={this.state}/>
              )}
            </div>
          </div>
          : this.state.selectedTab ?
            <ErrorMessage message={I18n.t("entry.services_must_ordered_seperately")} />
            : <ErrorMessage message={I18n.t("service_entry.no_services_available")} />
        }
        <hr/>
        <div className="pull-right">
          {this.props.secretary ?
              <a className="btn btn-default" href={this.props.return_path}>{`Return to Show`}</a>
              :
              ""
          }
          <a className="btn btn-default" onClick={() => this.handleSubmit('payer_payee')}>{I18n.t('wizard.back_button')}</a>
          <span> </span>
          <a className="btn btn-success" onClick={() => this.handleSubmit('fees')}>{I18n.t('wizard.next_button')}</a>
        </div>
        <br/><br/>
      </div>
    )
  }
}

export default EditEntryStep
